<template>
  <div class="page">
    <div v-if="loading">
      <lottie-player src="https://assets6.lottiefiles.com/packages/lf20_b88nh30c.json" background="transparent"
        speed="1" loop="true" autoplay></lottie-player>
    </div>
    <div v-else>
      <div v-if="valid">
        <div class="logo">
          <img :src="data.toko.logo_url" v-if="data.toko.logo_url" />
          <p>
            {{ data.toko.nama }} <br />
            {{ data.toko.no_telp }}<br />
            {{ data.toko.alamat }}<br />
          </p>
        </div>
        <div class="body">
          <div class="header">
            <table>
              <tr>
                <td>Nota</td>
                <td>:</td>
                <td>{{ data.penjualan.no_nota }}</td>
              </tr>
              <tr>
                <td>Meja</td>
                <td>:</td>
                <td>{{ data.penjualan.meja || "-" }}</td>
              </tr>
              <tr>
                <td>Tamu</td>
                <td>:</td>
                <td>{{ data.penjualan.tamu || "-" }}</td>
              </tr>
            </table>
          </div>
          <div class="detail">
            <ul>
              <li v-for="(item, index) in data.penjualan_detail" :key="index">
                <div>
                  <b>{{ item.nama }}</b>
                  <span>{{ item.jumlah }} x {{ item.harga | number }}</span>
                </div>
                <div>
                  <b>{{ (item.jumlah * item.harga) | number }}</b>
                </div>
              </li>
            </ul>
          </div>
          <div class="sum">
            <table>
              <tr>
                <td>Subtotal</td>
                <td>{{ data.subTotal | number }}</td>
              </tr>
              <tr>
                <td>Diskon</td>
                <td>{{ data.jumlahDiskon | number }}</td>
              </tr>
              <tr>
                <td>Pajak</td>
                <td>{{ data.jumlahPajak | number }}</td>
              </tr>
              <tr>
                <td>Total</td>
                <td>{{ data.grandTotal | number }}</td>
              </tr>
              <tr>
                <td colspan="2">&nbsp;</td>
              </tr>
              <tr v-if="data.penjualan.status == 'SUDAH_BAYAR'">
                <td>Bayar</td>
                <td>
                  <b>{{ data.penjualan.bayar | number }}</b>
                </td>
              </tr>
              <tr v-if="data.penjualan.status == 'SUDAH_BAYAR'">
                <td>Kembali</td>
                <td>
                  <b>{{ (data.penjualan.bayar - data.grandTotal) | number }}</b>
                </td>
              </tr>
            </table>
          </div>

          <div class="footer">
            <p>{{ data.toko.footer_text }}</p>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="not-found">
          <lottie-player src="https://assets10.lottiefiles.com/packages/lf20_dmw3t0vg.json" background="transparent"
            speed="1" loop="true" autoplay></lottie-player>
          <p>Transaksi tidak ditemukan</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as api from "./../api/Api";

export default {
  name: "Struk",
  data() {
    return {
      loading: true,
      valid: false,
      data: {
        toko: {},
        penjualan: {},
        penjualan_detail: [],
        subTotal: 0,
        jumlahDiskon: 0,
        jumlahPajak: 0,
        jumlahPembulatan: 0,
        grandTotal: 0,
      },
    };
  },
  methods: {
    load() {
      api.get("/v4/struk?guid=" + this.$route.params.guid).then((res) => {
        this.loading = false;
        if (res.valid) {
          this.valid = true;
          this.data = res.data;

          let subtotal = 0;
          this.data.penjualan_detail.forEach((item) => {
            subtotal += parseInt(item.jumlah) * parseInt(item.harga);
          });

          this.data.subTotal = subtotal;

          this.data.jumlahDiskon = this.data.penjualan.jumlah_diskon;
          this.data.jumlahPajak = this.data.penjualan.pajak;

          this.data.jumlahPembulatan = 0;
          if (this.data.penjualan.pembulatan_bawah > 0) {
            this.data.jumlahPembulatan = this.data.penjualan.pembulatan_bawah;
          } else if (this.data.penjualan.pembulatan_atas > 0) {
            this.data.jumlahPembulatan = this.data.penjualan.pembulatan_bawah;
          }

          this.data.grandTotal =
            parseInt(this.data.subTotal) -
            parseInt(this.data.jumlahDiskon) +
            parseInt(this.data.jumlahPajak) +
            parseInt(this.data.jumlahPembulatan);
        }
      });
    },
  },
  mounted() {
    this.load();
  },
};
</script>

<style lang="scss">
.page {
  padding: 20px;
}

.logo {
  text-align: center;
  margin-bottom: 40px;

  img {
    width: 100px;
    border: 1px solid #eee;
    border-radius: 50%;
    padding: 10px;
  }

  p {
    font-size: 15px;
  }
}

.body {
  margin-top: 20px;

  .header {
    padding-bottom: 10px;
    border-bottom: 1px solid #ccc;

    table {
      tr {
        td {
          font-size: 14px;

          &:nth-child(1) {
            padding-right: 10px;
          }

          &:nth-child(2) {
            padding-right: 5px;
          }
        }
      }
    }
  }

  .detail {
    margin-top: 10px;
    padding-bottom: 10px;
    border-bottom: 1px solid #ccc;

    ul {
      list-style-type: none;
      padding: 0;
      margin: 0;

      li {
        display: flex;
        justify-content: space-between;
        padding: 10px 0;
        font-size: 14px;

        b {
          display: block;
        }

        span {
          color: #777;
        }

        >div {
          &:nth-child(2) {
            display: flex;
            align-items: center;
          }
        }
      }
    }
  }

  .sum {
    margin-top: 15px;

    table {
      width: 100%;

      tr {
        td {
          font-size: 14px;
          padding: 2px 0;

          &:last-child {
            text-align: right;
          }
        }
      }
    }
  }

  .footer {
    p {
      padding-top: 30px;
      text-align: center;
      font-size: 14px;
    }
  }
}

.not-found {
  width: 250px;
  margin: 0 auto;
  padding: 40px 0;

  p {
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Struk.vue